/* eslint-disable react/jsx-pascal-case */
import { Type } from '@uswitch/spark'
import { useCategoryGuides } from './use-category-guides'
import { Fragment } from 'react'

import { usePageProps } from '../../compounds/category-guide-card'
import { categoryGuidesStylePath } from './index'

import { LinkConnected as Link } from '../../elements/link'

const Item = ({ guide }) => {
  const connectedEntity = guide?.fields?.variants?.length
    ? guide?.fields?.variants[0]
    : guide?.fields?.entry || guide.fields.link

  const { mappedProps } = usePageProps({ entity: connectedEntity })

  if (!connectedEntity) {
    return <></>
  }

  return (
    <div>
      <Link href={guide.fields.url} sx={{ variant: categoryGuidesStylePath('link') }}>
        {mappedProps.title}
      </Link>
    </div>
  )
}

const HtmlSitemapCategoryGuides = ({ title, guides = [] }) => {
  const filteredGuides = useCategoryGuides({ guides })
    .sort((a, b) => a.fields.url.localeCompare(b.fields.url))
    .filter(url => !url.fields.robotsMeta)

  return (
    <If condition={filteredGuides.length !== 0}>
      <Fragment>
        <If condition={title}>
          <Type.H3
            sx={{
              variant: categoryGuidesStylePath('title'),
            }}
          >
            {title}
          </Type.H3>
        </If>

        <For index='key' each='url' of={filteredGuides}>
          <Item guide={url} key={url.fields.url} />
        </For>
      </Fragment>
    </If>
  )
}

export default HtmlSitemapCategoryGuides
